"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LogMetadata_1 = require("../config/LogMetadata");

var TimeUtils_1 = require("../util/TimeUtils");

var OnelineLogFormat =
/*#__PURE__*/
function () {
  function OnelineLogFormat() {
    _classCallCheck(this, OnelineLogFormat);
  }

  _createClass(OnelineLogFormat, [{
    key: "format",
    value: function format(msg, metadata) {
      var time = msg.time_iso || new Date(msg.timestamp).toISOString() || TimeUtils_1.TimeUtils.getUTCISOTime();
      var name = LogMetadata_1.LogMetadata.getBestIdentifier(metadata);
      return "".concat(name, " | ").concat(time, " [").concat(msg.level, "]: ").concat(msg.message);
    }
  }, {
    key: "getName",
    value: function getName() {
      return OnelineLogFormat.FORMAT_NAME;
    }
  }]);

  return OnelineLogFormat;
}();

OnelineLogFormat.FORMAT_NAME = "oneline";
exports.OnelineLogFormat = OnelineLogFormat;